import toggleWorkspaceMenu from './toggleWorkspaceMenu';

export default toggleWorkspaceMenu;
